module.exports = __webpack_public_path__ + "img/instruction1.6cb254a7.gif";